var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSoriHappy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 358,
    height: 361,
    viewBox: "0 0 358 361",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_565_193456)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M342 174C342 195.405 337.784 216.601 329.592 236.377C321.401 256.153 309.394 274.122 294.258 289.258C279.122 304.394 261.153 316.401 241.377 324.592C221.601 332.784 200.405 337 179 337C157.595 337 136.399 332.784 116.623 324.592C96.8465 316.401 78.8775 304.394 63.7416 289.258C48.6056 274.122 36.5991 256.153 28.4076 236.377C20.2161 216.601 16 195.405 16 174L179 174H342Z",
    fill: "url(#paint0_linear_565_193456)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 84.5,
    cy: 176.5,
    r: 8.5,
    fill: "#41435B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 263.5,
    cy: 176.5,
    r: 8.5,
    fill: "#41435B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.5 209C164.667 214.333 178.5 221.4 192.5 207",
    stroke: "#41435B",
    strokeWidth: 8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283 46.5C285.167 38.8333 291.5 21.3 299.5 12.5",
    stroke: "#41435B",
    strokeWidth: 8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.5 58.5L322.5 50",
    stroke: "#41435B",
    strokeWidth: 8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254 43.5C254 37.5 253.5 23.7 251.5 16.5",
    stroke: "#41435B",
    strokeWidth: 8,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_565_193456",
    x: 0,
    y: 0.5,
    width: 358,
    height: 360.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.254902 0 0 0 0 0.262745 0 0 0 0 0.356863 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_565_193456"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.254902 0 0 0 0 0.262745 0 0 0 0 0.356863 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_565_193456",
    result: "effect2_dropShadow_565_193456"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_565_193456",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_565_193456",
    x1: 16,
    y1: 174,
    x2: 342,
    y2: 174,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A2BE3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.895154,
    stopColor: "#4FD5D9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoriHappy);
export default __webpack_public_path__ + "static/media/sori_happy.6774012bdd10b33e2b6c7c78e23335c2.svg";
export { ForwardRef as ReactComponent };